import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "11",
  viewBox: "0 0 11 11",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.44449 0.245436L5.4375 4.2525L1.43051 0.245443C1.10326 -0.081812 0.572684 -0.0818121 0.245436 0.245436L0.18032 0.318525C-0.0801424 0.647443 -0.0584372 1.12663 0.245436 1.43051L4.2525 5.4375L0.245443 9.44449C-0.081812 9.77174 -0.0818121 10.3023 0.245436 10.6296L0.318525 10.6947C0.647443 10.9551 1.12663 10.9334 1.43051 10.6296L5.4375 6.62175L9.44449 10.6296C9.77174 10.9568 10.3023 10.9568 10.6296 10.6296L10.6947 10.5565C10.9551 10.2276 10.9334 9.74837 10.6296 9.44449L6.62175 5.4375L10.6296 1.43051C10.9568 1.10326 10.9568 0.572684 10.6296 0.245436C10.3023 -0.0818121 9.77174 -0.0818121 9.44449 0.245436Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }